import { UserRole } from './user-role.enum';

class UserRoleHelperClass {
  protected _values: string[] = [];
  protected _keys: string[] = [];

  values(): string[] {
    return this._values;
  }

  keys(): string[] {
    return this._keys;
  }
  constructor() {
    for (const obj in UserRole) {
      if (!!obj) {
        this._values.push(UserRole[obj]);
        this._keys.push(obj);
      }
    }
  }

  checkRole(value: string): string {
    for (const obj in UserRole) {
      if (UserRole[obj] === value) {
        return UserRole[obj];
      }
    }
    return undefined;
  }
}

const UserRoleHelper = new UserRoleHelperClass();
export default UserRoleHelper;
